import Vue from 'vue';
import Vuex from 'vuex';
import User from './user';
import Notification from './notifications.js';
import DamageCase from './damagecase.js';
import RepairProof from './repairproof.js';
import RepairExtension from './repairextension.js';
import Documents from './documents.js';
import Logs from './logs';
import AppEmployee from './apps_employee.js';
import ProcessCreateOrderDocumentation from './processCreateOrderDocumentation';
import ProcessCreateComprehensive from './processCreateComprehensive';
import { defaultAxiosInstance } from '@/api/defaultConfiguration';
import { onRejected, onFulfilled } from '@/api/ResponseInterceptor';
import Serviceprovider from '@/store/serviceprovider';
import Customer from './customer.js';
import MarketingAds from './marketingAds.js';
import OnboardingCompanyData from './onboardingCompanyData.js';
import BrokerCompensation from './brokerCompensation.js';

Vue.use(Vuex);
// must be set here, because of Circular dependency between store and BaseRepository
defaultAxiosInstance.interceptors.response.use(onFulfilled, onRejected);

export default new Vuex.Store({
	state: {
		isMobileView: false,
		confirmLeaving: false,
		isMuteConfirmLeaving: false,
		modalTitle: '',
	},
	getters: {
		getIsMobileView(state) {
			return state.isMobileView;
		},
		getConfirmLeaving(state) {
			let confirmLeaving = state.confirmLeaving;
			// @ts-ignore
			confirmLeaving = typeof confirmLeaving === 'function' ? confirmLeaving() : confirmLeaving;
			return confirmLeaving;
		},
		getIsMuteConfirmLeaving(state) {
			return state.isMuteConfirmLeaving;
		},
		getModalTitle(state) {
			return state.modalTitle;
		},
	},
	mutations: {
		setIsMobileView(state, payload) {
			state.isMobileView = payload;
		},
		setConfirmLeaving(state, payload) {
			state.confirmLeaving = payload;
		},
		setMuteConfirmLeaving(state, payload) {
			state.isMuteConfirmLeaving = payload;
		},
		setModalTitle(state, payload) {
			state.modalTitle = payload;
		},
	},
	actions: {},
	modules: {
		user: User,
		notifications: Notification,
		damageCase: DamageCase,
		repairProof: RepairProof,
		repairExtension: RepairExtension,
		documents: Documents,
		appEmployee: AppEmployee,
		logs: Logs,
		processCreateOrderDocumentation: ProcessCreateOrderDocumentation,
		processCreateComprehensive: ProcessCreateComprehensive,
		serviceProvider: Serviceprovider,
		customer: Customer,
		onboardingCompanyData: OnboardingCompanyData,
		marketingAds: MarketingAds,
		brokerCompensations: BrokerCompensation,
	},
});
